import { Agreement01Icon } from '@hugeicons/react'

import { Card } from '@/shared/ui/Card'

import { MatchedTagList } from './MatchedTagList'

import type { SuggestedPartner, Suggestion } from '../model/types'

export const PartnerSuggestionCard = ({
  suggestion
}: {
  suggestion: Suggestion<SuggestedPartner>
}) => {
  const { record, matched_tags: matchedTags } = suggestion

  return (
    <Card href={`/parceiros/${record.slug}`} className="p-4">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-[0.625rem] bg-brand-surface">
          {record.logo?.file?.url ? (
            <img
              src={record.logo.file.url}
              alt=""
              className="h-full w-full object-cover"
            />
          ) : (
            <Agreement01Icon size={20} className="text-primary opacity-45" />
          )}
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-base font-semibold text-foreground">
            {record.name}
          </p>

          <div className="mt-3">
            <MatchedTagList tags={matchedTags} />
          </div>
        </div>
      </div>
    </Card>
  )
}
